import { useEffect, type ReactNode } from "react";
import { useHeaderContext } from "./HeaderContext.tsx";

interface HeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

/**
 * Pages call <Header title="..." subtitle="..." action={...} />.
 * Renders nothing — pushes props into HeaderContext so the shell topbar renders them.
 */
export default function Header({ title, subtitle, action }: HeaderProps) {
  const { setHeader } = useHeaderContext();

  useEffect(() => {
    setHeader({ title, subtitle, action });
  }, [title, subtitle, action, setHeader]);

  return null;
}
